import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { LoginFormValues } from "./types";

export const validationSchema: yup.SchemaOf<LoginFormValues> = yup.object().shape({
  email: yup
    .string()
    .email(i18n.t(Translations.LoginRouteEmailInvalid))
    .required(i18n.t(Translations.LoginRouteEmailRequired)),
  password: yup.string().required(i18n.t(Translations.LoginRoutePasswordRequired)),
});
